const { getAxiosInstance } = require('../connection');

module.exports = {
    fetchMetrics: function (eventId) {
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/metrics',
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },

    fetchData: function (eventId, metricIds) {
        // metricIds should be a list of int's
        let metricIdsParam = metricIds.join(',');
        return getAxiosInstance({
            url:  '/events/' + encodeURIComponent(eventId) + '/stats-data?metric_ids=' + encodeURIComponent(metricIdsParam),
            method: 'GET',
            json: true,
        }).then((response) => response.data);
    },
};
